import { Component, Injectable, signal, computed, inject, ChangeDetectionStrategy, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterState } from '../interfaces/generatorsmodel';
@Injectable({
    providedIn: 'root'
  })
export class FilterService {
  private storageKey = 'app_filter_states';
  saveState(state: FilterState) {
    console.log(`Saving State for Tab ${state.tabIndex}:`, state);
    const allStates = this.getAllStates();
    allStates[state.tabIndex] = state;
    localStorage.setItem(this.storageKey, JSON.stringify(allStates));
  }

  // Get state for a specific tab
  getState(tabIndex: number): FilterState | null {
    const allStates = this.getAllStates();
    return allStates[tabIndex] || null;
  }

  private getAllStates(): Record<number, FilterState> {
    const saved = localStorage.getItem(this.storageKey);
    return saved ? JSON.parse(saved) : {};
  }

  // Clear all saved states
  clearAll() {
    localStorage.removeItem(this.storageKey);
  }
}